/* eslint-disable */
/* report dispatch*/

const REPORT_DISPATCH = {
  REPORT_DISPATCH_DELIVERYPACK_MASTER: 'report/dispatch/deliveryPack/master',
  REPORT_DISPATCH_DETAIL_MASTER: 'report/dispatch/detail/master',
  REPORT_DISPATCH_DELIVERYPACK_INDIVIDUAL: 'report/dispatch/deliveryPack/individual',
  REPORT_DISPATCH_DETAIL_INDIVIDUAL: 'report/dispatch/detail/individual',
  REPORT_DISPATCH_DELIVERYPACK_COMPLETE: 'report/dispatch/deliveryPack/complete',
  REPORT_DISPATCH_DETAIL_COMPLETE: 'report/dispatch/detail/complete',
  REPORT_DISPATCH_DELIVERYPACK_DETAIL: 'report/dispatch/deliveryPack/detail',
  REPORT_DISPATCH_DETAIL_DETAIL: 'report/dispatch/detail/detail',
  REPORT_DISPATCH_DELIVERYPACK_UNASSIGNED: 'report/dispatch/deliveryPack/unAssigned',
  REPORT_DISPATCH_DELIVERYPACK_SORT: 'report/dispatch/deliveryPack/sort',
  REPORT_DISPATCH_DELIVERYPACK_POLYGONSEARCH_BYASSIGN: 'report/dispatch/deliveryPack/polygonSearch/byAssign',
  REPORT_DISPATCH_DELIVERYPACK_POLYGONSEARCH_BYTRAFFICPLAN: 'report/dispatch/deliveryPack/polygonSearch/byTrafficPlan',
  REPORT_DISPATCH_DELIVERYPACK_ASSIGNED_BYEDIT: 'report/dispatch/deliveryPack/assigned/byEdit',
  REPORT_DISPATCH_DELIVERYPACK_POLYGONSEARCH_BYEDIT: 'report/dispatch/deliveryPack/polygonSearch/byEdit',
  REPORT_DISPATCH_DELIVERYPACK_COLUMN: 'report/dispatch/deliveryPack/column',
  REPORT_DISPATCH_DELIVERYPACK_DELIVERY_TIME: 'report/dispatch/deliveryPack/delivery/time',
  REPORT_DISPATCH_DELIVERYPACK_DELIVERY_LOCATION: 'report/dispatch/deliveryPack/delivery/location',
  REPORT_DISPATCH_DELIVERYPACK_COORDINATE_NOTEDITED: 'report/dispatch/deliveryPack/coordinate/notEdited',
  REPORT_DISPATCH_DELIVERYPACK_COORDINATE_INCOMPATIBLE: 'report/dispatch/deliveryPack/coordinate/incompatible',
  REPORT_DISPATCH_DRIVER_ALL: 'report/dispatch/driver/all',
  REPORT_DISPATCH_DRIVER_BYPLAN: 'report/dispatch/driver/byPlan',
  REPORT_DISPATCH_DRIVER_UNASSIGNED: 'report/dispatch/driver/unAssigned',
  REPORT_DISPATCH_PLAN_ALL: 'report/dispatch/plan/all',
  REPORT_DISPATCH_PLAN_BYDRIVER: 'report/dispatch/plan/byDriver',
  REPORT_DISPATCH_PRODUCT_BYPLAN: 'report/dispatch/product/byPlan',
  REPORT_DISPATCH_PRODUCT_BYDISPATCH: 'report/dispatch/product/byDispatch',
  REPORT_DISPATCH_PRODUCT_BYDRIVER: 'report/dispatch/product/byDriver',
  REPORT_DISPATCH_PRODUCT_INVOICE_BYDISPATCH: 'report/dispatch/product/invoice/byDispatch',
  REPORT_DISPATCH_PRODUCT_INVOICE_BYDRIVER: 'report/dispatch/product/invoice/byDriver',
  REPORT_DISPATCH_PRODUCT_INVOICE_BYPLAN: 'report/dispatch/product/invoice/byPlan',
  REPORT_DISPATCH_CART_INVOICES_JASON: 'report/jasper/dispatch/cart/invoices/json',
  REPORT_DISPATCH_CART_PRODUCTS_JASON: 'public/cartStationProduct/report',
  REPORT_DISPATCH_CART_PRODUCTS_JASON_RE_REPORT: 'public/cartStationProduct/reReport',
  REPORT_DISPATCH_PAYMENT_DETAIL: 'report/dispatch/payment/detail',
  REPORT_DISPATCH_PAYMENT_MASTER: 'report/dispatch/payment/master',
  REPORT_DISPATCH_PAYMENT_STATISTICAL: 'report/dispatch/payment/statistical',
  REPORT_DISPATCH_REMAIN_AMOUNT: 'report/dispatch/deliveryPack/remain',
  REPORT_DISPATCH_DELIVERYPACK_RETURNED_ALL: 'report/dispatch/deliveryPack/returned',
  REPORT_DISPATCH_INCOMING_BYTIME: 'report/dispatch/incoming/byTime',
  REPORT_DISPATCH_INCOMING_BYPROVIDER: 'report/dispatch/incoming/byProvider',
  REPORT_DISPATCH_GEO_ALL: 'report/dispatch/geo/all',
  REPORT_DISPATCH_DELIVERYPACK_REJECTED: 'report/dispatch/deliveryPack/rejected',
  REPORT_DISPATCH_DELIVERYPACK_REASSIGNED: 'report/dispatch/deliveryPack/reAssigned',
  REPORT_DISPATCH_SETTLEMENT_INVOICEITEMS: 'report/dispatch/settlement/invoiceItems',
  REPORT_DISPATCH_SETTLEMENT_INVOICES: 'report/dispatch/settlement/invoices',
  REPORT_DISPATCH_SETTLEMENT: 'report/dispatch/settlement/settlement',
  REPORT_DISPATCH_SETTLEMENT_WITHOUTSETTLEMENT: 'report/dispatch/settlement/withoutSettlement',
  REPORT_DISPATCH_DELIVERYPACK_BY_BARCODE: 'report/dispatch/deliveryPack/byBarcode',
  REPORT_DISPATCH_DELIVERYPACK_INCOMPATIBLE_ALL: 'report/dispatch/deliveryPack/incompatible/all',
  REPORT_DISPATCH_DELIVERYPACK_DELIVERED_DETAIL: 'report/dispatch/deliveryPack/delivered/detail',
  REPORT_DISPATCH_DELIVERYPACK_DELIVERED_MASTER: 'report/dispatch/deliveryPack/delivered/master',
  REPORT_DISPATCH_DRIVER_RECIEVED_MASTER: 'report/dispatch/driver/received/master',
  REPORT_DISPATCH_PARCEL_LABEL: 'report/dispatch/parcel/label',

  REPORT_DISPATCH_DRIVER_RECIEVED_DETAILS: 'report/dispatch/driver/received/detail',
  REPORT_DISPATCH_ORDERCOMPARISION_BASEONORDER: 'report/dispatch/orderComparison/basedOnOrder',
  REPORT_DISPATCH_ORDERCOMPARISION_BASEONDISPATCH: 'report/dispatch/orderComparison/basedOnDispatch'
}

export default REPORT_DISPATCH
